import { withAuthenticationRequired } from '@tom-ui/utils'
import { ContainerYardOperationDialog } from '@host/components/container-change-position-dialog/ContainerYardOperationDialog'
import { ContainerYardOperationViewStore } from '@host/components/container-change-position-dialog/ContainerYardOperationViewStore'
import { parseBaplie } from '@host/utils/baplie-parser-utils'
import { OrdersPage } from '@tom-ui/planning'
import { useMemo } from 'react'
import { renderIsoCodeMappingInput } from '../IsoCodeMapping/IsoCodeMappingWrapper'

export const OrdersPageWrapper = withAuthenticationRequired(() => {
  const containerYardOperationViewStore = useMemo(() => {
    return new ContainerYardOperationViewStore()
  }, [])

  return (
    <>
      <OrdersPage
        renderIsoCodeMappingInput={renderIsoCodeMappingInput}
        containerYardOperationViewStore={containerYardOperationViewStore}
        parseBaplie={parseBaplie}
      />
      <ContainerYardOperationDialog store={containerYardOperationViewStore} />
    </>
  )
})
